import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-project-twitch',
  templateUrl: './project-twitch.component.html',
  styleUrls: ['./project-twitch.component.scss']
})
export class ProjectTwitchComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
